import { injectAppConfirm, injectSnackbarError, injectSnackbar } from "@/composables/injections";
import { useTranslation } from "i18next-vue";
import { apolloClient } from "@/plugins/apollo/index.js";
import { gql } from "@apollo/client/core";
import { showLoadingButton } from "@/utils/showLoadingButton";
export function usePersonRoleActions() {
    const { appConfirm } = injectAppConfirm();
    const { snackbar, snackbarClose } = injectSnackbar();
    const { snackbarServerError } = injectSnackbarError();
    const { t } = useTranslation();
    async function terminatePersonRole(item, evt) {
        let removeLoading = null;
        try {
            const response = await appConfirm(t("people:personRoleTerminate.heading", "Terminate person's role"), t("people:personRoleTerminate.question", "Are you sure, you would like to terminate person´s role? The role will be terminated as of today"));
            if (!response)
                return;
            if (evt)
                removeLoading = showLoadingButton(evt.target);
            //snackbar("loading");
            await apolloClient.mutate({
                mutation: gql `
          mutation personRoleTerminate($id: ID!) {
            personRoleTerminate(input: { id: $id }) {
              personRole {
                id
                expiresAt
                allowedMutations
              }
            }
          }
        `,
                variables: {
                    id: item.id
                }
            });
            //snackbarClose();
        }
        catch (error) {
            snackbarServerError(error, { level: "error" });
        }
        finally {
            if (removeLoading)
                removeLoading();
        }
    }
    return {
        terminatePersonRole
    };
}
